export default __webpack_public_path__ + "static/media/TrashCan.218f9809.svg";